import { useEffect, useRef, useState, type FormEvent } from "react";
import { useSearchParams } from "react-router";
import { completeMfa } from "./authApi";
import { AuthActions, AuthField, AuthNotice, AuthPage, SubmitButton, showResult } from "./authKit";

/** Claves de texto de la pantalla (las que lee LoginMfa.razor). */
export const mfaTextKeys = ["MFA_TITLE", "MFA_HINT", "MFA_CODE", "MFA_SUBMIT", "MFA_ERROR"];

/**
 * Segundo factor (LoginMfa.razor) con las piezas del kit: el desafío viaja firmado en ?token=. El código escrito se
 * conserva tras un error, que siempre muestra MFA_ERROR, sin el motivo.
 */
export function LoginMfaPage({ L }: { L: (key: string) => string }) {
  const [params] = useSearchParams();
  const [otp, setOtp] = useState("");
  const [failed, setFailed] = useState(0);
  const [sending, setSending] = useState(false);
  const busy = useRef(false);
  const title = L("MFA_TITLE");
  useEffect(() => {
    document.title = title;
  }, [title]);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (busy.current) return;
    busy.current = true;
    setSending(true);
    let leaving = false;
    try {
      const result = await completeMfa({ token: params.get("token"), otp });
      if (result.status === "signedIn" && result.next) {
        leaving = true;
        window.location.assign(result.next);
        return;
      }
      showResult(() => setFailed((value) => value + 1), false);
    } finally {
      if (!leaving) {
        busy.current = false;
        setSending(false);
      }
    }
  };

  return (
    <AuthPage title={title}>
      <p className="auth-intro">{L("MFA_HINT")}</p>
      {failed ? (
        <AuthNotice key={failed} tone="error">
          {L("MFA_ERROR")}
        </AuthNotice>
      ) : null}
      <form method="post" onSubmit={(event) => void submit(event)}>
        <AuthField id="otp" label={L("MFA_CODE")}>
          <input
            id="otp"
            name="form.Otp"
            value={otp}
            onChange={(event) => setOtp(event.target.value)}
            inputMode="numeric"
            autoComplete="one-time-code"
            required
          />
        </AuthField>
        <AuthActions>
          <SubmitButton sending={sending}>{L("MFA_SUBMIT")}</SubmitButton>
        </AuthActions>
      </form>
    </AuthPage>
  );
}
